import { useQuery } from 'react-query'
import { fetchWrapper } from 'src/utils/fetchWrapper'
import type { AddonsItems } from 'src/types/manageWorkOrder'

export function useAddonsItems(woId: number) {
  const API_ENDPOINT = `/addOns/${woId}/list`
  return useQuery('addonsItemsList', async () => {
    return await fetchWrapper<AddonsItems[]>({
      method: 'GET',
      url: API_ENDPOINT,
    })
  })
}
